import api from "./api";

const { accountServiceAccountAPI } = api;

const DROP_DOWN_DATA_PATH = "/role/filter";
const FETCH_ROLE_LIST_PATH = "/role"
const DELETE_ROLE_PATH = "/role/"
const FETCH_FEATURE_ACCESS_PATH = "/role/feature"
const FETCH_FEATURE_ACCESS_BY_ROLE_PATH = "/role/feature/"
const CREATE_ROLE_PATH = "/role"
const UPDATE_ROLE_PATH = "/role/"
const FETCH_ACCESS_ROLE_FEATURE_DROPDOWN_PATH = "/role/featureList"
const FETCH_ACCESS_ROLE_FEATURE_PATH = "/role/feature/accessRoles/"
const SAVE_ACCESS_ROLE_FEATURE_PATH = "/role/feature/accessRoles"
const FETCH_USER_LIST_PATH = "/user"
const DELETE_USER_PATH = "/user/"
const FETCH_USERS_WITH_ROLES_BY_ID_PATH = "/user/"
const FETCH_USERS_ROLES_ONLOAD_PATH = "/user/load"
const CREATE_UPDATE_USER_PATH = "/user"
const FETCH_GROUP_LIST_PATH = "/group/list"
const CREATE_GROUP_PATH = "/group"
const UPDATE_GROUP_PATH = "/group/"
const ONLOAD_GROUP_PATH = "/group/onload"
const DELETE_GROUP_PATH = "/group/"
const ONLOAD_ROLE_PATH = "/role/onload"
const FETCH_ROLE_USERS_PATH = "/user/roles/"
const FETCH_VENDOR_USER_MANAGEMENT_ONLOAD_PATH = "/vendorUserManagement/onload"

const AccountService = {
  getFilterOptions: async (fetchRoles = true, fetchGroups = true, fetchStatus = true, type?: string) => {
    try {
      const queryParams = new URLSearchParams({
        isRole: String(fetchRoles),
        isGroup: String(fetchGroups),
        isStatus: String(fetchStatus),
      });
      
      // Add type parameter if provided
      if (type) {
        queryParams.append('type', type);
      }

      const url = `${DROP_DOWN_DATA_PATH}?${queryParams.toString()}`;

      const resp = await accountServiceAccountAPI.get(url);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
  getRoleList: async (type?: string) => {
    try {
      let url = FETCH_ROLE_LIST_PATH;
      
      // Add type parameter if provided
      if (type) {
        url += `?type=${type}`;
      }
      
      const resp = await accountServiceAccountAPI.get(url); 
      return resp.data; 
    } catch (error) {
      throw error; 
    }
  },
  deleteRole: async (id: string, type?: string) => {
    try {
      let url = DELETE_ROLE_PATH + id;
      
      // Add type parameter if provided
      if (type) {
        url += `?type=${type}`;
      }
      
      const resp = await accountServiceAccountAPI.delete(url);
      console.log("Role Deleted: ", resp.status);
      return resp.status;
    } catch (error) {
      throw error;
    }
  },
  getFeatureAccess: async (type?: string) => {
    try {
      let url = FETCH_FEATURE_ACCESS_PATH;
      
      // Add type parameter if provided
      if (type) {
        url += `?type=${type}`;
      }
      
      const resp = await accountServiceAccountAPI.get(url); 
      return resp.data; 
    } catch (error) {
      throw error; 
    }
  },
  getFeatureAccessByRole: async (roleId: string, type?: string) => {
    try {
      let url = FETCH_FEATURE_ACCESS_BY_ROLE_PATH + roleId;
      
      // Add type parameter if provided
      if (type) {
        url += `?type=${type}`;
      }
      
      const resp = await accountServiceAccountAPI.get(url); 
      return resp.data; 
    } catch (error) {
      throw error; 
    }
  },
  createRole: async (payload: RolePayload, type?: string) => {
    try {
      let url = CREATE_ROLE_PATH;
      
      // Add type parameter if provided
      if (type) {
        url += `?type=${type}`;
      }
      
      const resp = await accountServiceAccountAPI.post(url, payload);
      return resp.status;
    } catch (error) {
      throw error;
    }
  },
  updateRole: async (roleId: string, payload: RolePayload, type?: string) => {
    try {
      let url = UPDATE_ROLE_PATH + roleId;
      
      // Add type parameter if provided
      if (type) {
        url += `?type=${type}`;
      }
      
      const resp = await accountServiceAccountAPI.put(url, payload);
      return resp.status;
    } catch (error) {
      throw error;
    }
  },
  getAccessRoleFeatureDropdownData: async (type?: string) => {
    try {
      let url = FETCH_ACCESS_ROLE_FEATURE_DROPDOWN_PATH;
      
      // Add type parameter if provided
      if (type) {
        url += `?type=${type}`;
      }
      
      const resp = await accountServiceAccountAPI.get(url); 
      return resp.data; 
    } catch (error) {
      throw error; 
    }
  },
  getAccessRolesByFeature: async (id: string, type?: string) => {
    try {
      let url = FETCH_ACCESS_ROLE_FEATURE_PATH + id;
      
      // Add type parameter if provided
      if (type) {
        url += `?type=${type}`;
      }
      
      const resp = await accountServiceAccountAPI.get(url); 
      return resp.data; 
    } catch (error) {
      throw error; 
    }
  },
  saveAccessRolesByFeature: async (payload: Payload, type?: string) => {
    try {
      let url = SAVE_ACCESS_ROLE_FEATURE_PATH;
      
      // Add type parameter if provided
      if (type) {
        url += `?type=${type}`;
      }
      
      const resp = await accountServiceAccountAPI.post(url, payload);
      return resp;
    } catch (error) {
      throw error;
    }
  },

  // New function for saving role access permissions with the correct payload structure
  saveRoleAccessPermissions: async (payload: any, type?: string) => {
    try {
      let url = CREATE_ROLE_PATH;
      
      // Add type parameter if provided
      if (type) {
        url += `?type=${type}`;
      }
      
      const resp = await accountServiceAccountAPI.post(url, payload);
      return resp;
    } catch (error) {
      throw error;
    }
  },
  getUsersList: async (isVendorUsers?: boolean) => {
    try {
      let url = FETCH_USER_LIST_PATH;

      // Add vendor parameter if provided
      if (isVendorUsers) {
        url += `?type=VENDOR`;
      }
      
      const resp = await accountServiceAccountAPI.get(url); 
      return resp.data; 
    } catch (error) {
      throw error; 
    }
  },
  deleteUserById: async (id: string, isVendorUsers?: boolean) => {
    try {
      let url = DELETE_USER_PATH + id;
      
      // Add vendor parameter if provided
      if (isVendorUsers) {
        url += `?type=VENDOR`;
      }

      const resp = await accountServiceAccountAPI.delete(url);
      console.log("User Deleted: ", resp.status);
      return resp.status;
    } catch (error) {
      throw error;
    }
  },
  getUserWithRoles: async (roleId : string) => {
    try {
      const resp = await accountServiceAccountAPI.get( FETCH_USERS_WITH_ROLES_BY_ID_PATH + roleId); 
      return resp.data; 
    } catch (error) {
      throw error; 
    }
  },
  getUserRolesOnloadData: async (isVendorUsers?: boolean) => {
    try {
      let url = FETCH_USERS_ROLES_ONLOAD_PATH;
      
      // Add vendor parameter if provided
      // if (isVendorUsers !== undefined) {
      //   url += `?type=VENDOR`;
      // }
      if (isVendorUsers) {
        url += `?type=VENDOR`;
      }
      
      const resp = await accountServiceAccountAPI.get(url); 
      return resp.data; 
    } catch (error) {
      throw error; 
    }
  },
  createUpdateUser: async (payload: UserPayload, isVendorUsers?: boolean) => {
    try {
      let url = CREATE_UPDATE_USER_PATH;
      
      // Add vendor parameter if provided
      if (isVendorUsers) {
        url += `?type=VENDOR`;
      }
      
      const resp = await accountServiceAccountAPI.post(url, payload);
      return resp.status;
    } catch (error) {
      throw error;
    }
  },
  getGroupsList: async () => {
    try {
      const resp = await accountServiceAccountAPI.get(FETCH_GROUP_LIST_PATH); 
      return resp.data; 
    } catch (error) {
      throw error; 
    }
  },
  createGroup: async (payload: GroupPayload) => {
    try {
      const resp = await accountServiceAccountAPI.post(CREATE_GROUP_PATH, payload);
      return resp.status;
    } catch (error) {
      throw error;
    }
  },
  updateGroup: async (roleId : string, payload :GroupPayload) => {
    try {
      const resp = await accountServiceAccountAPI.put(UPDATE_GROUP_PATH + roleId, payload);
      return resp.status;
    } catch (error) {
      throw error;
    }
  },
  getGroupOnloadData: async () => {
    try {
      const resp = await accountServiceAccountAPI.get( ONLOAD_GROUP_PATH ); 
      return resp.data; 
    } catch (error) {
      throw error; 
    }
  },
  deleteGroup: async (id: string) => {
    try {
      const resp = await accountServiceAccountAPI.delete( DELETE_GROUP_PATH + id );
      console.log("Group Deleted: ", resp.status);
      return resp.status;
    } catch (error) {
      throw error;
    }
  },
  getRoleOnloadData: async (type?: string) => {
    try {
      let url = ONLOAD_ROLE_PATH;
      
      // Add type parameter if provided
      if (type) {
        url += `?type=${type}`;
      }
      
      const resp = await accountServiceAccountAPI.get(url); 
      return resp.data; 
    } catch (error) {
      throw error;
    }
  },
  fetchAllUsersWithRole: async (roleId : string) => {
    try {
      const resp = await accountServiceAccountAPI.get( FETCH_ROLE_USERS_PATH + roleId ); 
      return resp.data; 
    } catch (error) {
      throw error; 
    }
  },
  getVendorUserEditModalData: async () => {
    try {
      // This method should fetch vendor user data for the edit modal
      // For now, returning mock data structure - replace with actual API call
      const resp = await accountServiceAccountAPI.get("/vendor/user/edit-data");
      return resp.data;
    } catch (error) {
      // Fallback to mock data if API fails
      return {
        firstName: "",
        lastName: "",
        emailId: "",
        companyName: "",
        vendorRole: "",
        vendorUserGroup: "",
        status: "Active"
      };
    }
  },
  findByVendorUserId: async (token?: string) => {
    try {
      const config: any = {
        // Disable default auth interceptor to use guest token
        auth: false,
      };
      
      // Always use the provided guest token for authentication
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
      } else {
        // If no token provided, fallback to default auth
        config.auth = true;
        delete config.headers?.Authorization;
      }
      
      const resp = await accountServiceAccountAPI.get('/vendor/findByVendorUserId', config);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
  switchVendor: async (vendorId: string, token?: string) => {
    try {
      const config: any = {
        // Disable default auth interceptor to use guest token
        auth: false,
      };
      
      // Always use the provided guest token for authentication
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
      } else {
        // If no token provided, fallback to default auth
        config.auth = true;
        delete config.headers?.Authorization;
      }
      
      const resp = await accountServiceAccountAPI.post(`/vendor/switch/${vendorId}`, {}, config);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },


};

export default AccountService;
